import { Box , Image, SPImageSource } from "arkh";
import React, { useMemo } from "react";
import { StyleSheet } from "react-native";
import {
  FileIcon,
  FileIconRelay,
  FileIconType,
} from "../FileListItem/FileIcon";
import Color from "color";
import { graphql, useFragment } from "react-relay";
import { FileThumbnail_file$key } from "./__generated__/FileThumbnail_file.graphql";
import { getFileTypeColor } from "./getFileTypeColor";

export const EmaginThumbnail = React.memo(InnerEmaginThumbnail);

export const FileThumbnail = React.memo(InnerFileThumbnail);
function InnerEmaginThumbnail({
  color,
  size,
  image,
  type,
  isLoading,
}: {
  color: string;
  size: number;
  image: SPImageSource | null;
  type: FileIconType | null;
  isLoading?: boolean;
}) {
  return (
    <Box
      cornerRadius="medium"
      color="surface"
      style={{
        borderColor: color,
        borderWidth: StyleSheet.hairlineWidth,
        width: size,
        height: size,
        overflow: "hidden",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {image ? (
        <Image
          {...image}
          style={{
            width: size,
            height: size,
          }}
        />
      ) : (
        <FileIcon filetype={isLoading ? "loading" : type} size={40} />
      )}
      <Box
        style={{
          position: "absolute",
          top: 10,
          left: 10,
          backgroundColor: Color(color).lighten(0.48).toString(),
        }}
        cornerRadius="medium"
        space="small"
      >
        <FileIcon filetype={type} size={20} />
      </Box>
    </Box>
  );
}

function InnerFileThumbnail(props: { size: number; file: FileThumbnail_file$key }) {
  const file = useFragment(
    graphql`
      fragment FileThumbnail_file on File {
        type
        status
        isOrg
        ...FileIcon_File
        thumbnail {
          id
          ...Image_image
        }
      }
    `,
    props.file
  );
  const isLoading = file.status !== "READY" && file.status !== "ERROR";

  const color = useMemo(
    () => getFileTypeColor(file.isOrg ? "org" : file.type),
    [file.isOrg, file.type]
  );

  const size = props.size;
  return (
    <Box
      cornerRadius="medium"
      color="surface"
      style={{
        borderColor: color,
        borderWidth: StyleSheet.hairlineWidth,
        width: size,
        height: size,
        overflow: "hidden",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {file.thumbnail ? (
        <Image
          type="remote"
          image={file.thumbnail}
          style={{
            width: size,
            height: size,
          }}
        />
      ) : isLoading ? (
        <FileIcon filetype="loading" />
      ) : (
        <FileIconRelay file={file} size={40} />
      )}
      <Box
        style={{
          position: "absolute",
          top: 10,
          left: 10,
          backgroundColor: Color(color).lighten(0.48).toString(),
        }}
        cornerRadius="medium"
        space="small"
      >
        <FileIconRelay file={file} size={20} />
      </Box>
    </Box>
  );
}
